import type { GetArAgingReportResponse } from '@vy/api-definition';
import type { ItemOf } from '@vy/utils';
import { isNotEmptyArray } from '@vy/utils';
import { useCallback, useState } from 'react';
import type { FilterLineType } from '../../../../../components/new-design/vyTableFilter';
import { matchesLabelSelection, matchesStringSelection } from '../../../reports-components/shared-filter-fields';
import { AR_AGING_FILTER_FIELD_IDS } from './use-ar-aging-filter-fields';

type BreakdownItem = ItemOf<GetArAgingReportResponse['summaryBreakdown']>;

type FilterPredicate = (item: BreakdownItem, value: unknown) => boolean;

const FIELD_PREDICATES: Record<string, FilterPredicate> = {
  [AR_AGING_FILTER_FIELD_IDS.CUSTOMER]: (item, value) =>
    matchesStringSelection(item.customer.name, value),

  [AR_AGING_FILTER_FIELD_IDS.LABEL]: (item, value) =>
    matchesLabelSelection(item.labels?.map((l) => l.id) ?? [], value),

  [AR_AGING_FILTER_FIELD_IDS.SUBSIDIARY]: (item, value) =>
    matchesStringSelection(item.subsidiaryName ?? null, value),
};

export function useArAgingFilters() {
  const [filters, setFilters] = useState<FilterLineType[]>([]);

  const handleFilterChange = useCallback((filterLines: FilterLineType[]) => {
    setFilters(filterLines);
  }, []);

  return { filters, handleFilterChange };
}

export function applyArAgingFilters(
  breakdown: GetArAgingReportResponse['summaryBreakdown'],
  filters: FilterLineType[],
): GetArAgingReportResponse['summaryBreakdown'] {
  if (!isNotEmptyArray(filters)) {
    return breakdown;
  }

  return breakdown.filter((item) =>
    filters.every((filter) => {
      const predicate = FIELD_PREDICATES[filter.field];

      if (!predicate) {
        return true;
      }

      return predicate(item, filter.value);
    }),
  );
}
